module.exports = __webpack_public_path__ + "85c0c57e8ab6b18c22f6b6e56a67d68a.ttf";